module.exports = __webpack_public_path__ + "static/media/labor-rights.e9ebf5ec.jpg";